document.addEventListener('DOMContentLoaded', function() {
  
  var modal = document.getElementById('modal');
  var modal_overlay = document.getElementById('modal-overlay');
  var closeModal = document.getElementById('close-modal');

  var modalImage = document.getElementById('modal-image');
  var modalDescription = document.getElementById('modal-description');

  var lifetimeWarranty = document.getElementById('lifetime-warranty');
  var lifetimeUpgrade = document.getElementById('lifetime-upgrade');

  lifetimeWarranty.addEventListener('click', function() {
    modal.style.display = "block";
    modal_overlay.style.display = "block";
    modalImage.src = "https://cdn.shopify.com/s/files/1/0063/6741/2260/files/Gold_Urban_DURABILITY.png?v=1713191921";
    modalDescription.textContent = "Take the risk out of your purchase. We guarantee our products for life. All of our pieces are sweat proof and waterproof.";
  });

  lifetimeUpgrade.addEventListener('click', function() {
    modal.style.display = "block";
    modal_overlay.style.display = "block";
    modalImage.src = "https://cdn.shopify.com/s/files/1/0063/6741/2260/files/Lifetime_Upgrade_Arrow.png?v=1713195565";
    modalDescription.textContent = "Never lose money on jewelry ever again. We will take back your jewelry at full purchase price on anything 2x higher priced. Just pay the difference.";
  });

  closeModal.addEventListener('click', function() {
    modal.style.display = "none";
    modal_overlay.style.display = "none";
  });

    modal_overlay.addEventListener('click', function() {
    modal_overlay.style.display = "none";
    modal.style.display = "none";
    
  });

  window.addEventListener('click', function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      modal_overlay.style.display = "none";
    }
  });

});
